import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import React from 'react';
import PropTypes from 'prop-types';
import { useBrand } from '@atc/brand';
import { Link, SubHeading, Glyphicon } from 'reaxl';
import clsx from 'clsx';

/**
 *  Renders a Listing Title element
 *
 */
function InventoryListingTitle(props) {
  const {
    title,
    size,
    render,
    uiContext,
    offsite = false,
    ...rest
  } = props;
  const {
    isBrand
  } = useBrand();
  const isFord = isBrand('ford');
  const titleElement = /*#__PURE__*/_jsx(SubHeading, {
    componentClass: "h2",
    size: size,
    className: clsx('margin-bottom-4', {
      'link-unstyled': rest.href
    })
  }, "listing-title", title, offsite && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    className: "margin-left-1",
    glyph: "offsite",
    "aria-label": "External Link"
  }))));
  const linkProps = {
    ...rest,
    undecorated: true
  };

  // If brand=ford, then do not use rel=sponsored,nofollow for SEO purposes
  if (!isFord && uiContext === 'sponsored') {
    linkProps.rel = 'sponsored,nofollow';
  }

  // allow render function to define returned element
  if (typeof render === 'function') {
    return render({
      titleElement
    });
  }

  // only apply a Link if there is an href
  if (!rest.href) {
    return titleElement;
  }
  return /*#__PURE__*/React.createElement(Link, linkProps, titleElement);
}
export default InventoryListingTitle;